import { Slider } from "@/components/ui/slider";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { useEffect, useState } from "react";
import {
  setHotelFilters,
  useHotelFilter,
} from "../../state/extract-hotel-filter-slice";
import { HotelAccordion } from "./hotel-accordion";

export const HotelPriceRangeFilter = () => {
  const dispatch = useAppDispatch();
  const { defaultOption, selectedOption } = useAppSelector(useHotelFilter);
  const isLoading = useAppSelector(
    (state) => state.selectedHotelData.isLoading,
  );

  const state = defaultOption?.priceRange;
  const state_min_price = state?.min ?? null;
  const state_max_price = state?.max ?? null;

  const { max: prMax, min: prMin } = selectedOption?.priceRange ?? {};

  const [priceRange, setPriceRange] = useState<[number | null, number | null]>([
    null,
    null,
  ]);

  useEffect(() => {
    if (state_min_price && state_max_price) {
      setPriceRange((prev) => {
        if (prev[0] === state_min_price && prev[1] === state_max_price)
          return prev;
        return [state_min_price, state_max_price];
      });
    }
  }, [state_min_price, state_max_price]);

  useEffect(() => {
    if (
      prMin !== null &&
      prMin !== undefined &&
      prMax !== null &&
      prMax !== undefined
    ) {
      setPriceRange((prev) => {
        if (prev[0] === prMin && prev[1] === prMax) return prev;
        return [prMin, prMax];
      });
    }
  }, [prMin, prMax]);

  const handleChange = (val: number[]) => {
    setPriceRange([val[0], val[1]]);
  };

  const onValueCommit = (range: number[]) => {
    dispatch(setHotelFilters({ priceRange: { min: range[0], max: range[1] } }));
  };

  // if (state?.min == state?.max) return null;

  if (state_min_price && state_max_price && priceRange[0] && priceRange[1])
    return (
      <HotelAccordion value={"price"} label={"Price Range"}>
        <>
          <Slider
            disabled={isLoading}
            defaultValue={priceRange as number[]}
            onValueCommit={onValueCommit}
            min={state_min_price as number}
            max={state_max_price as number}
            step={1}
            onValueChange={handleChange}
            value={priceRange as number[]}
          />
          <div className="flex justify-between">
            <span className="text-sm">
              BDT {priceRange[0]?.toLocaleString()}
            </span>
            <span className="text-sm">
              BDT {priceRange[1]?.toLocaleString()}
            </span>
          </div>
        </>
      </HotelAccordion>
    );

  return null;
};

HotelPriceRangeFilter.displayName = "HotelPriceRangeFilter";
